import { Box, FormControlLabel, Radio, RadioGroup, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { type ActiveQualificationWithLicenses } from "../hooks/useActiveQualificationsWithLicenses";
import type { StepProps } from "../types";

interface StateSelectionStepProps extends StepProps {
  selectedQualification: ActiveQualificationWithLicenses | undefined;
}

export function StateSelectionStep({
  state,
  actions,
  selectedQualification,
}: StateSelectionStepProps) {
  if (!selectedQualification) {
    return null;
  }

  return (
    <Box>
      <RadioGroup
        value={state.selectedLicenseId ?? ""}
        onChange={(event) => {
          actions.handleLicenseSelect(event.target.value);
        }}
      >
        <Stack spacing={3}>
          {selectedQualification.licenses.map((license) => (
            <FormControlLabel
              key={license.id}
              value={license.id}
              control={<Radio />}
              labelPlacement="start"
              label={<Text variant="body1">{license.attributes.state}</Text>}
              sx={(theme) => ({
                width: "100%",
                justifyContent: "space-between",
                margin: theme.spacing(0),
              })}
            />
          ))}
        </Stack>
      </RadioGroup>
    </Box>
  );
}
